module.exports = __webpack_public_path__ + "static/img/logo-zggl.c305820b.png";